import React, { Component } from "react"
import { compose } from "redux"
import { connect } from "react-redux"
import { firestoreConnect } from "react-redux-firebase"
import GalleryItemImage from "../Gallery/GalleryItemImage/GalleryItemImage"

class GalleryPhotos extends Component {
  constructor() {
    super()
    this.state = {
      loading: true,
      error: false,
      Collage: [],
    }
  }
  componentDidMount() {
    const docRef = this.props.firebase
      .firestore()
      .collection("collage")
      .orderBy("position", "asc")

    docRef
      .get()
      .then((querySnapshot) => {
        const Collage = []
        querySnapshot.forEach((doc) => {
          const { url, position, Idproduct, name, price, code } = doc.data()
          Collage.push({
            id: doc.id,
            url,
            position,
            Idproduct,
            name,
            price,
            code,
          })
        })

        if (Collage.length) {
          this.setState(() => ({ loading: false, Collage, error: false }))
        } else {
          this.setState(() => ({ loading: false, error: true }))
        }
      })
      .catch((error) => {
        this.setState({ error: true, loading: false })
      })
  }
  render() {
    if (this.state.Collage[0]) {
      var imagen1 = this.state.Collage[0]
      var imagen2 = this.state.Collage[1]
      var imagen3 = this.state.Collage[2]
      var imagen4 = this.state.Collage[3]
      var imagen5 = this.state.Collage[4]
      var imagen6 = this.state.Collage[5]
      var imagen7 = this.state.Collage[6]
      var imagen8 = this.state.Collage[7]
      var imagen9 = this.state.Collage[8]
      var imagen10 = this.state.Collage[9]
      var imagen11 = this.state.Collage[10]
    }

    return (
      <>
        <div className='text-center pb-5 pt-5'>
          <h2 className='font-weight-bold'>Nuevos Diseños</h2>
        </div>
        <div>
          <GalleryItemImage
            imagen1={imagen1 !== undefined && imagen1}
            imagen2={imagen2 !== undefined && imagen2}
            imagen3={imagen3 !== undefined && imagen3}
            imagen4={imagen4 !== undefined && imagen4}
            imagen5={imagen5 !== undefined && imagen5}
            imagen6={imagen6 !== undefined && imagen6}
            imagen7={imagen7 !== undefined && imagen7}
            imagen8={imagen8 !== undefined && imagen8}
            imagen9={imagen9 !== undefined && imagen9}
            imagen10={imagen10 !== undefined && imagen10}
            imagen11={imagen11 !== undefined && imagen11}
          />
        </div>
      </>
    )
  }
}

export default compose(
  firestoreConnect((props) => [{ collection: "arreglos" }]),
  connect(({ firestore: { data } }) => ({
    arreglos: data.arreglos,
  }))
)(GalleryPhotos)
